import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FORGE_NPM_PACKAGE_NAME } from "@/constants";

interface CommandBannerProps {
  className?: string;
}

export const CommandBanner: React.FC<CommandBannerProps> = ({
  className = "",
}) => {
  const [copied, setCopied] = useState(false);
  const command = `npx ${FORGE_NPM_PACKAGE_NAME}@latest`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className={`group relative overflow-hidden border-0 ${className}`}>
      <div className="relative py-6">
        <div className="flex items-center justify-between gap-6">
          <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="flex-1 min-w-0 space-y-3">
              <div className="flex items-center gap-2">
                <h1 className="text-lg font-bold text-blue-900 dark:text-blue-100">
                  Install Forge AI Assistant
                </h1>
              </div>
              <div className="flex items-center gap-3 p-4 bg-gradient-to-r from-blue-100/80 to-indigo-100/80 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-xl border border-blue-200/60 dark:border-blue-700/60 transition-colors duration-200 shadow-inner">
                <code className="flex-1 text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-mono font-semibold text-blue-800 dark:text-blue-200 break-all">
                  {command}
                </code>
                <Button
                  onClick={handleCopy}
                  variant="ghost"
                  size="sm"
                  className="h-10 w-10 p-0 hover:bg-blue-200/60 dark:hover:bg-blue-800/40 rounded-lg transition-all duration-200 hover:scale-110 active:scale-95 flex-shrink-0 shadow-md hover:shadow-lg"
                  title={copied ? "Copied!" : "Copy command"}
                >
                  {copied ? (
                    <Check className="h-5 w-5 text-green-600 dark:text-green-400" />
                  ) : (
                    <Copy className="h-5 w-5 text-blue-600 dark:text-blue-400" />
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
